"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _headers = require("next/headers");
var _ = require("../..");
var getAccountInfo = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (scheme, tetheredUserGuid) {
    var _cookies$get$value, _cookies$get;
    var token = (_cookies$get$value = (_cookies$get = (0, _headers.cookies)().get(_.ID_TOKEN_COOKIE)) === null || _cookies$get === void 0 ? void 0 : _cookies$get.value) !== null && _cookies$get$value !== void 0 ? _cookies$get$value : '';
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getAccountInfoQuery)(), {
      scheme: scheme,
      tetheredUserId: tetheredUserGuid
    }, result => {
      var _result$data;
      return result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.getAccountInfo;
    }, token, true, false);
    return response;
  });
  return function getAccountInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports.default = getAccountInfo;